
export const ExternalLink = ({
  href = '',
  children,
  id,
  style,
  className,
}) => {
  const isValidHref = href && typeof href === 'string' && href.toLowerCase().startsWith('https://');
  if (!isValidHref) {
    console.warn('ExternalLink component: Invalid or unsafe href provided:', href);
    return null;
  }

  return (
    <a
      {...{ id, href, style, className }}
      target="_blank"
      rel="noopener noreferrer"
    >
      {children}
    </a>
  );
};
